import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonBadge,
  IonButton,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonThumbnail,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { fileTrayStacked, star, starOutline } from 'ionicons/icons';
import { formatDate } from '../../utils/date.utils';

addIcons({ star, starOutline, fileTrayStacked });

@Component({
  selector: 'crowdctrl-workspace-item',
  standalone: true,
  imports: [CommonModule, IonItem, IonLabel, IonThumbnail, IonBadge, IonButton, IonIcon, IonImg],
  templateUrl: './workspace-item.component.html',
  styleUrl: './workspace-item.component.css',
})
export class WorkspaceItemComponent implements OnChanges {
  @Input() workspaceName!: string;
  @Input() status?: string;
  @Input() thumbnailUrl?: string | null;
  @Input() createdAt?: string | Date;
  @Input() createdByEmail?: string | null;
  @Input() button = false;
  @Input() detail = false;
  @Input() lines?: string;
  @Input() showBookmark = false;
  @Input() isBookmarked = false;
  @Input() isTogglingBookmark = false;
  @Output() click = new EventEmitter<void>();
  @Output() bookmarkToggle = new EventEmitter<void>();

  thumbnailLoadFailed = false;

  formatDate = formatDate;

  ngOnChanges(changes: SimpleChanges): void {
    if ('thumbnailUrl' in changes) {
      this.thumbnailLoadFailed = false;
    }
  }

  get showThumbnailImage(): boolean {
    return !!this.thumbnailUrl && !this.thumbnailLoadFailed;
  }

  onThumbnailError(): void {
    this.thumbnailLoadFailed = true;
  }

  getBadgeColor(status?: string): string {
    const normalizedStatus = this.normalizeStatus(status);
    switch (normalizedStatus) {
      case 'active':
        return 'success';
      case 'inactive':
        return 'medium';
      case 'archived':
        return 'medium';
      case 'disabled':
        return 'danger';
      default:
        return 'medium';
    }
  }

  getBadgeText(status?: string): string {
    if (!status) {
      return '';
    }
    // Convert to Sentence case: first letter uppercase, rest lowercase
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }

  private normalizeStatus(status?: string): string {
    if (!status) {
      return '';
    }
    return status.toLowerCase();
  }

  onItemClick(): void {
    this.click.emit();
  }

  onBookmarkToggle(event: Event): void {
    event.stopPropagation();
    this.bookmarkToggle.emit();
  }
}
